// extracted by mini-css-extract-plugin
export default {"navigationWrap":"ReferralNavigate_navigationWrap__KDTCr","hit":"ReferralNavigate_hit__nfim9"};